import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiClient } from '../api/client';

export default function AccessPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await apiClient.post('/portal/request-access', { email });
      setSent(true);
    } catch {
      setError('Errore di rete. Riprova tra qualche minuto.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>

      {/* ── Thin top bar ── */}
      <div className="public-nav-bar" style={{ flexShrink: 0 }}>
        <div className="public-nav-bar-inner">
          <Link to="/register" style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.875rem' }}>Iscrizioni</Link>
          <Link to="/accesso" style={{ color: '#fff', fontSize: '0.875rem', fontWeight: 600 }}>Accedi</Link>
        </div>
      </div>

      {/* ── Two-column body ── */}
      <div className="access-layout">

        {/* Left: branded panel */}
        <div className="access-left">
          {/* Decorative circles */}
          <div style={{ position: 'absolute', width: 480, height: 480, borderRadius: '50%', border: '1px solid rgba(255,255,255,0.06)', top: -180, right: -120 }} />
          <div style={{ position: 'absolute', width: 300, height: 300, borderRadius: '50%', border: '1px solid rgba(255,255,255,0.07)', bottom: -100, left: 60 }} />

<div style={{ position: 'relative', textAlign: 'center', maxWidth: 400 }}>
            <h2 style={{ color: '#fff', fontFamily: 'var(--font-public)', fontWeight: 800, fontSize: '1.875rem', margin: '0 0 1rem', lineHeight: 1.2 }}>
              Bentornato nel portale
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: '1rem', lineHeight: 1.7, margin: 0 }}>
              Accedi alla tua area personale per consultare i materiali, seguire le sessioni e gestire le iscrizioni.
            </p>

          </div>
        </div>

        {/* Right: form panel */}
        <div className="access-right">
          {/* Steps */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '2.5rem' }}>
            {[
              { icon: '📚', label: 'Materiali didattici e registrazioni' },
              { icon: '🗓️', label: 'Le tue iscrizioni ai corsi' },
              { icon: '🔗', label: 'Link Zoom per partecipare' },
            ].map(item => (
              <div key={item.label} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', color: 'var(--gray-600)', fontSize: '0.9rem' }}>
                <span style={{ fontSize: '1.1rem', flexShrink: 0 }}>{item.icon}</span>
                {item.label}
              </div>
            ))}
          </div>
          {sent ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '3.5rem', marginBottom: '1.25rem' }}>📬</div>
              <h2 style={{ color: 'var(--pub-navy)', fontFamily: 'var(--font-public)', fontWeight: 700, marginBottom: '0.75rem', fontSize: '1.5rem' }}>
                Email inviata!
              </h2>
              <p style={{ color: 'var(--gray-600)', marginBottom: '1rem', lineHeight: 1.65, fontSize: '0.9375rem' }}>
                Se <strong>{email}</strong> è registrata nel sistema, riceverai a breve il link di accesso personale.
              </p>
              <p style={{ fontSize: '0.875rem', color: 'var(--gray-400)', marginBottom: '2rem' }}>
                Controlla anche la cartella spam.
              </p>
              <button
                className="btn-pub-outline"
                onClick={() => { setSent(false); setEmail(''); }}
                style={{ width: '100%' }}
              >
                Prova con un'altra email
              </button>
            </div>
          ) : (
            <>
              <div style={{ marginBottom: '2.5rem' }}>
                <h2 style={{ color: 'var(--pub-navy)', fontFamily: 'var(--font-public)', fontWeight: 800, fontSize: '1.75rem', margin: '0 0 0.5rem', lineHeight: 1.15 }}>
                  Accedi alla tua area
                </h2>
                <p style={{ color: 'var(--gray-500)', margin: 0, fontSize: '0.9375rem', lineHeight: 1.55 }}>
                  Inserisci la tua email e ti inviamo il link personale.
                </p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="form-group" style={{ marginBottom: '1.25rem' }}>
                  <label className="form-label" htmlFor="email">Indirizzo email</label>
                  <input
                    id="email"
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="nome@azienda.it"
                    required
                    autoFocus
                    style={{ fontSize: '1rem' }}
                  />
                </div>

                {error && (
                  <div className="alert alert-danger" style={{ marginBottom: '1rem' }}>{error}</div>
                )}

                <button
                  type="submit"
                  className="btn-pub-cta"
                  style={{ width: '100%', fontSize: '1rem', padding: '0.875rem' }}
                  disabled={loading || !email}
                >
                  {loading ? (
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
                      <span className="spinner" style={{ width: 16, height: 16 }} />
                      Invio in corso…
                    </span>
                  ) : 'Invia link di accesso'}
                </button>
              </form>

              <p style={{ textAlign: 'center', marginTop: '2rem', fontSize: '0.875rem', color: 'var(--gray-400)' }}>
                Non sei ancora iscritto?{' '}
                <Link to="/register" style={{ color: 'var(--pub-blue)', fontWeight: 500 }}>Registrati qui</Link>
              </p>
            </>
          )}
        </div>
      </div>

      {/* ── Footer ── */}
      <footer style={{
        background: 'var(--pub-navy)', color: 'rgba(255,255,255,0.55)',
        fontSize: '0.8125rem', textAlign: 'center', padding: '1rem 2rem',
        fontFamily: 'var(--font-public)', flexShrink: 0,
      }}>
        {import.meta.env.VITE_FOOTER_TEXT}
      </footer>
    </div>
  );
}
